import React from "react";
import "../Styles/Header.css";

const Header = () => {
  return (
    <>
      <div className="header-container">
        <div className="top-bar">
          <p className="contact">
  CALL: <a href="tel:9943936999">99439 36999</a>, 
  <a href="mailto: info@gainwissdom.in" target="_blank" rel="noreferrer">Mail To : info@gainwissdom.in</a>
</p>


        </div>
        <div className="social-icons">
          <a
            href="https://twitter.com/JeseeFrancis"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../Assets/X.png")}
              alt="X"
              className="icon-logo"
            />
          </a>

          <a
            href=" https://www.instagram.com/jeseefrancis/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../Assets/instagram.png")}
              alt="Instagram"
              className="icon-logo"
            />
          </a>

          <a
            href="mailto:info@gainwissdom.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../Assets/email.png")}
              alt="Email"
              className="icon-logo"
            />
          </a>

          <a
            href="https://www.linkedin.com/in/jesee-francis-ab7622a"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={require("../Assets/linkedin.png")}
              alt="LinkedIn"
              className="icon-logo"
            />
          </a>
          <a
          href=" https://youtube.com/@jeseefrancis7779"
          target="_blank"
          rel="noopener noreferrer">
          <img
            src={require("../Assets/youtube.png")}
            alt="Location"
            className="icon-logo"
          /></a>
        </div>
      </div>
    </>
  );
};

export default Header;
